import React, {useMemo} from 'react';
import DetailLayout from '../../../../Components/Layout/DetailLayout';
import {Link, useParams} from 'react-router-dom';
import useRequest from '../../../../Utils/Hooks/useRequest';
import {getTenantViewInfo} from '../service';
import {Descriptions, DescriptionsProps, Skeleton, Space, Spin} from 'antd';
import Style from './index.module.scss';
import OrderHistory from './Components/OrderHistory';
import {useDict} from '../dict';

const Index = () => {
    const {id} = useParams<{id: string}>();
    const [data, {loading}, reload] = useRequest(() => getTenantViewInfo(id!));
    const dict = useDict();

    const infos = useMemo<{
        topInfo: DescriptionsProps['items'];
        baseInfo: DescriptionsProps['items'];
        bigDataInfo: DescriptionsProps['items'];
    }>(() => {
        if (data) {
            return {
                topInfo: [
                    {
                        label: '方案',
                        children: data.versionName,
                    },
                    {
                        label: '用户数',
                        children: `${data.userNumber}/${data.maxUserNumber}`,
                    },
                    {
                        label: '主体',
                        children: data.serviceSubject,
                    },
                    {
                        label: '到期时间',
                        children: data.expirationEndTime,
                    },
                    {
                        label: '管理端地址',
                        children: (
                            <a
                                target="_blank"
                                href={`//${data.subjectDomainName}${process.env['REACT_APP_HREF_ADMIN']}`}>
                                {data.subjectDomainName}
                                {process.env['REACT_APP_HREF_ADMIN']}
                            </a>
                        ),
                    },
                    {
                        label: '移动端地址',
                        children: (
                            <Link
                                target="_blank"
                                to={`/mobile/${data.subjectDomainName}`}>
                                {data.subjectDomainName}
                            </Link>
                        ),
                    },
                    {
                        label: '创建人',
                        children: data.createUser,
                    },
                    {
                        label: '联系人',
                        children: data.contacts,
                    },
                    {
                        label: '租户账号',
                        children: data.adminLoginName,
                    },
                    {
                        label: '联系电话',
                        children: data.phone,
                    },
                    {
                        label: '地址',
                        children: data.locationDetail,
                        span: 2,
                    },
                ],
                baseInfo: [
                    {
                        label: '注册时间',
                        children: data.createTime,
                    },
                    {
                        label: '注册渠道',
                        children: dict.RegBy.getName(data.signInType),
                    },
                    {
                        label: 'AppSecret',
                        children: data.appSecret,
                    },
                    {
                        label: 'AppSalt',
                        children: data.appSalt,
                    },
                ],
                bigDataInfo: [
                    {
                        label: '方案',
                        children: data?.versionName2,
                    },
                    {
                        label: '用户数',
                        children: data?.maxUserNumber2,
                    },
                    {
                        label: '状态',
                        children: dict.TenantStatus.getName(data?.status2),
                    },
                ],
            };
        }
        return {
            topInfo: [],
            baseInfo: [],
            bigDataInfo: [],
        };
    }, [data]);

    return (
        <DetailLayout>
            <Spin spinning={loading}>
                {!data && <Skeleton paragraph={{rows: 15}} />}
                {data && (
                    <Space
                        direction="vertical"
                        size={50}
                        className={Style.space}>
                        <Descriptions
                            column={2}
                            title={`${data.name}  ${data.code}`}
                            bordered
                            items={infos.topInfo}
                        />
                        <Descriptions
                            column={2}
                            bordered
                            title="基本信息"
                            items={infos.baseInfo}
                        />
                        <Descriptions
                            column={2}
                            bordered
                            title="大数据"
                            items={infos.bigDataInfo}
                        />
                        <div>
                            <DetailLayout.Title>订单记录</DetailLayout.Title>
                            {id && (
                                <OrderHistory
                                    customerId={id}
                                    onReload={reload}
                                />
                            )}
                        </div>
                    </Space>
                )}
            </Spin>
        </DetailLayout>
    );
};

export default Index;
